import tlds from 'tlds';
import React from 'react';
import PropTypes from 'prop-types';
import linkifyIt from 'linkify-it';
import { css } from '@emotion/react';
import { EditorState } from 'draft-js';
import { useFormContext } from 'react-hook-form';

import EditorUtils from '../../draft-js-plugins-utils/src';
import { PictureIcon } from '../../../../../../images/Icons';
import { WithUploadImage } from '../../../../../WithUploadImage/WithUploadImage';
import { isBomBombVideoSelected } from '../../draft-js-bombbomb-plugin';

import addImage from './modifiers/addImage';

const linkify = linkifyIt();
linkify.tlds(tlds);

const ImageButton = (props) => {
  const { id } = useFormContext().getValues();
  const modalRef = React.useRef();
  const [value, setValue] = React.useState('');
  const onMouseDown = (event) => {
    event.preventDefault();
  };

  const onClick = (e) => {
    if (e.target !== e.currentTarget) return;
    e.preventDefault();
    e.stopPropagation();
    const imageInstance = EditorUtils.getCurrentEntity(props.store?.getEditorState?.());
    const url = imageInstance ? imageInstance.getData().src : '';
    setValue(url);
    modalRef.current?.toggleModal(true, url);
  };

  const onChange = React.useCallback((src) => {
    const editorState = props.store?.getEditorState?.();
    if (!editorState) return;
    const entityKey = EditorUtils.getCurrentEntityKey(editorState);
    if (entityKey) {
      const contentState = editorState.getCurrentContent();
      const newContentState = contentState.mergeEntityData(entityKey, { src });
      const newEditorState = EditorState.push(editorState, newContentState, 'apply-entity');

      const selection = editorState.getSelection();
      const anchorKey = selection.getAnchorKey();
      const anchorBlock = contentState.getBlockForKey(anchorKey);

      props.setEditorState(
        EditorState.forceSelection(
          newEditorState,
          selection.merge({
            anchorKey: anchorKey,
            focusKey: anchorKey,
            anchorOffset: anchorBlock.getText().length,
            focusOffset: anchorBlock.getText().length,
          })
        )
      );
    } else {
      const newState = addImage(editorState, src);
      props.setEditorState(newState);
    }
    modalRef.current?.toggleModal(false);
  }, []);

  const { theme } = props;

  let hasLinkedImage = false;
  const editorState = props.store?.getEditorState?.();
  const hasImageSelected = editorState ? EditorUtils.hasEntity(editorState, 'IMAGE') : false;
  const imageInstance = EditorUtils.getCurrentEntity(editorState);
  const link =
    imageInstance && imageInstance.getData().src
      ? linkify.match(imageInstance.getData().src)
      : null;
  const isBombBombVideo = editorState ? isBomBombVideoSelected(editorState) : false;
  if (hasImageSelected && typeof link !== 'undefined' && link !== null && !isBombBombVideo) {
    hasLinkedImage = true;
  }
  const ImageButtonStyle = hasLinkedImage ? [theme.button, theme.active] : theme.button;
  const buttonWrapper = props?.title
    ? hasLinkedImage
      ? [theme.buttonGroup, theme.active]
      : theme.buttonGroup
    : undefined;

  let refValue;
  if (typeof value === 'string') {
    refValue = { url: value, imageUrl: value };
  } else {
    refValue = value;
  }

  const onChangeImage = React.useCallback(
    (val) => {
      onChange && onChange(val?.imageUrl);
    },
    [props]
  );

  let asset = props.asset;
  if (!props.asset) {
    asset = {
      entity: 'ewebinar',
      entityId: id,
      name: 'image',
      fit: 'contain',
      container: {
        width: 425,
      },
    };
  }

  return (
    <div css={buttonWrapper}>
      <button
        css={[
          css`
            margin-left: 0.125rem;
          `,
          ImageButtonStyle,
        ]}
        onClick={onClick}
        type='button'
      >
        <PictureIcon
          css={css`
            width: 1.4rem;
            height: 1.4rem;
            pointer-events: none;
          `}
        />
        <WithUploadImage
          ref={modalRef}
          name='image'
          asset={asset}
          value={refValue}
          onChange={onChangeImage}
          allowThirdPartyURLs
        >
          {() => null}
        </WithUploadImage>
      </button>
      {props?.title && <span>{props.title}</span>}
    </div>
  );
};

ImageButton.propTypes = {
  placeholder: PropTypes.string,
  store: PropTypes.object.isRequired,
  ownTheme: PropTypes.object.isRequired,
  validateUrl: PropTypes.func,
  asset: PropTypes.object,
  title: PropTypes.string,
};

export default ImageButton;
